import { createAction } from "@reduxjs/toolkit";

const authAction = createAction("AUTH", (payload) => {
  return payload;
});

export { authAction };
